import { http } from '@/api/http';
import type { Outcome } from '@/api/outcome';
import type { Repertoire } from './types';

export interface ListResponse {
  count: number;
  repertoires: Repertoire[];
}

export interface ItemsResponse {
  module: 'opening';
  repertoire: Repertoire;
  pgn: string;
  modes_available: Array<'recall' | 'plan' | 'punish' | 'survival'>;
}

export interface AttemptPayload {
  module: 'opening';
  slug: string;
  fen: string;
  side_to_move: 'white' | 'black';
  mode: 'recall' | 'plan' | 'punish' | 'survival' | 'mirror';
  result: 'success' | 'partial' | 'fail';
  played_move?: string;
  expected_move?: string;
  time_spent_ms: number;
  source_ref?: string;
  /** MVP2.4 T9.1 — 5 états (cf. @/api/outcome). Optionnel pour rétro-compat. */
  outcome?: Outcome;
}

export interface AttemptResponse {
  attempt_id: number;
  item_id: number;
  card_created: boolean;
  card_id: number | null;
}

export const openingLabApi = {
  list: () => http.get<ListResponse>('/api/v1/content/openings'),
  fetchItems: (slug: string) =>
    http.get<ItemsResponse>(`/api/v1/training/items?module=opening&repertoire_slug=${encodeURIComponent(slug)}`),
  postAttempt: (payload: AttemptPayload) => http.post<AttemptResponse>('/api/v1/training/attempts', payload),
};
